import { render, staticRenderFns } from "./AccountOptions.vue?vue&type=template&id=021f575e&scoped=true"
var script = {}
import style0 from "./AccountOptions.vue?vue&type=style&index=0&id=021f575e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021f575e",
  null
  
)

export default component.exports